const DEFAULT_PRIMARY_COLOR = '#6D8FA4';

export function normalizeBrandColor(value: unknown) {
  return typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value.trim())
    ? value.trim().toUpperCase()
    : DEFAULT_PRIMARY_COLOR;
}
export function getReadableBrandText(primaryColor: string) {
  const hex = primaryColor.replace('#', '');
  const red = Number.parseInt(hex.slice(0, 2), 16);
  const green = Number.parseInt(hex.slice(2, 4), 16);
  const blue = Number.parseInt(hex.slice(4, 6), 16);
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance > 0.62 ? '#17252D' : '#FFFFFF';
}
